import { useMenu as g } from "../../hooks/useMenu.js";
import { useCallback as h } from "react";
import { usePopover as I } from "../../../Popover/hooks/usePopover.js";
const N = ({
  canToggle: t,
  onClick: r,
  onFocus: a,
  onKeyDown: c,
  selected: f,
  value: i
}) => {
  const s = g(), S = I(), d = s != null && s.supportsSelection ? s.isSelected(i) : f, o = h(
    (l) => {
      r == null || r(l), M(s, i, d, S, t);
    },
    [t, s, r, S, d, i]
  ), e = h(
    (l) => {
      c == null || c(l), l.key === "Tab" && (s != null && s.supportsSelection) && (s != null && s.changeOnBlur) && (s == null || s.toggle(i, !0));
    },
    [s, c, i]
  );
  return {
    onClick: o,
    onFocus: a,
    onKeyDown: e
  };
}, M = (t, r, a, c, f) => {
  var i;
  t != null && t.supportsSelection && t.toggle(r, f || t != null && t.multiSelect ? !a : !0), t != null && t.hasArrowKeyNav && !(t != null && t.multiSelect) && ((i = c == null ? void 0 : c.setShow) == null || i.call(c, !1));
};
export {
  N as useMenuItemInteractions
};
